import React from "react";
import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose } from "redux";
import reducers from "./reducers";
import thunk from "redux-thunk";

import { BrowserRouter as Router } from "react-router-dom";

import SidePanel from "./components/SidePanel";
import MainOutcomes from "./components/MainOutcomes";
import FabButtons from "./components/FabButtons";
import { initial } from "lodash";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default class Outcomes extends React.Component {
  componentWillMount() {
    const {
      start_date,
      end_date,
      group_ids,
      group_categories,
      organization_name,
      permissions,
      therapists,
      resident_statuses,
    } = this.props;
    this.setState(() => {
      return {
        start_date,
        end_date,
        group_ids,
        group_categories,
        organization_name,
        permissions,
        therapists,
        resident_statuses,
      };
    });
  }

  search = (q, requestMadeFrom) => {
    window.location.href = `outcomes?group_ids=${q.group_ids}&start_date=${q.start_date}&end_date=${q.end_date}&reqFrom=${requestMadeFrom}&group_categories=${q.group_categories}&resident_statuses=${q.resident_statuses}`;
  };

  exportCSV = (q, requestMadeFrom) =>
    (window.location.href = `outcomes/reason_for_discharge.csv?group_id=${q.group_id}&start_date=${q.start_date}&end_date=${q.end_date}&reqFrom=${requestMadeFrom}`);

  store = (initialState) => {
    return createStore(
      reducers,
      {
        static: initialState,
        residents: initialState.residents,
        filters: {
          start_date: initialState.start_date,
          end_date: initialState.end_date,
          group_id: initialState.group_id,
          group_ids: initialState.group_ids,
          group_categories: initialState.group_categories,
          resident_statuses: initialState.resident_statuses,
        },
        settings: {
          hiddenOutcomes: initialState.hidden_outcomes,
        },
      },
      composeEnhancers(applyMiddleware(thunk))
    );
  };

  render() {
    const { showSidePanel, height } = this.props.config;
    return (
      <Provider store={this.store(this.props)}>
        <div className="d-flex align-items-start" style={{ height }}>
          <Router>
            {showSidePanel && <SidePanel variant="popover" />}
            <FabButtons />
            <div
              className="h-100 d-lg-flex align-items-start w-100 main-container"
              style={{
                backgroundColor: "rgba(256,256,256,0.5)",
                overflowY: "hidden",
              }}
            >
              {showSidePanel && <SidePanel />}
              <MainOutcomes {...this.props} />
            </div>
          </Router>
        </div>
      </Provider>
    );
  }
}
